module.exports = __webpack_public_path__ + "media/connectivity-slide3.a38a095c.mp4";